if (process.env.NODE_ENV === 'production') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.js
 **/